'use client';

/* eslint-disable @eslint-react/no-array-index-key -- static skeleton placeholders */
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton for collection workflow
 */
export function CollectionWorkflowSkeleton() {
  return (
    <div className="container mx-auto max-w-6xl space-y-8 p-6">
      {/* Progress indicator skeleton */}
      <div className="flex items-center justify-center space-x-2">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-0.5 w-12" />
        <Skeleton className="h-8 w-8 rounded-full" />
      </div>

      {/* Step header skeleton */}
      <div className="space-y-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>

      {/* Institution cards skeleton */}
      <div className="grid gap-4 md:grid-cols-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="space-y-3 rounded-lg border p-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-4 w-4" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-20 rounded-full" />
              <Skeleton className="h-6 w-24 rounded-full" />
            </div>
          </div>
        ))}
      </div>

      {/* Navigation skeleton */}
      <div className="flex items-center justify-between pt-4">
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  );
}
